export default __webpack_public_path__ + "static/media/07Amazon60s.684c927f.mp3";